// This Component displays a list of items
// A show list Item and a h2 title

import { Col, Row } from "react-bootstrap";
import InsurranceItem from "./InsurranceItem";
import { Loader } from "./Loader";
import { Zoom } from "react-awesome-reveal";

function InsurranceListShowcase({ items, isLoading, lg }) {
  return (
    <>
      <Row className="justify-content-md-center">
        {isLoading ? (
          <Loader lg={lg} />
        ) : (
          items?.map((item) => (
            <Col key={item.slug} lg={lg} md={6} className="d-flex">
              <Zoom triggerOnce duration={1250}>
                <InsurranceItem
                  title={item.name}
                  description={item.description}
                  slug={item.slug}
                  image={item.image}
                />
              </Zoom>
            </Col>
          ))
        )}
      </Row>
    </>
  );
}

export default InsurranceListShowcase;
